import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// IMPORT COMPONENT FOR ROUTING

import { LabourJobComponent } from './labour-job.component';
import { LabourJobListComponent } from './../labour-job-list/labour-job-list.component';
import { LabourJobCreateEditComponent } from './../labour-job-create-edit/labour-job-create-edit.component';
import { LabourJobViewComponent } from './../labour-job-view/labour-job-view.component';
import { LabourJobCreateComponent } from '../labour-job-create/labour-job-create.component';


const routes: Routes = [
  {
    path: '',
    component: LabourJobComponent,
    children: [
      {
        path: 'list',
        component: LabourJobListComponent
      },
      {
        path: 'create',
        component: LabourJobCreateComponent
      },
      {
        path: 'view/:jobid',
        component: LabourJobViewComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LabourJobRoutingModule { }
